import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState<number>(0);
  const total = pageSamples.length;
  const goTo = (next: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(total - 1, next));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  };
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track || track.clientWidth === 0) return;
    const current = Math.round(track.scrollLeft / track.clientWidth);
    if (current !== index) setIndex(current);
  };
  return <section id="inside-pages" className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-122" data-mp="3pmeu5g2ssjhh">
      <div className="mx-auto max-w-5xl" data-id="element-123" data-mp="3kvq3g2yxzqje">
        <div className="mx-auto max-w-2xl text-center" data-id="element-124" data-mp="3kuogp18kdflu">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-125" data-mp="1mmmdnghh7ttw">
            Przejrzyj materiały
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-126" data-mp="1rk4dmhdimypr">
            Zobacz strony{' '}
            <span className="italic text-brand" data-id="element-127" data-mp="1hve2aewl5ye3">od środka.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-128" data-mp="1ht9o944z3j03">
            Prawdziwe strony z pakietu, od pierwszych kart pracy z klasy 4 po
            infografiki dla liceum.
          </p>
        </div>

        <div ref={trackRef} onScroll={handleScroll} role="group" aria-roledescription="karuzela" aria-label="Przykładowe strony materiałów" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
      }} className="no-scrollbar mt-10 flex w-full snap-x snap-mandatory overflow-x-auto overscroll-x-contain rounded-3xl focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-129" data-mp="uvg8glmwf5xr">
          {pageSamples.map((page, pageIndex) => <article key={page.src} aria-roledescription="slajd" aria-label={`${pageIndex + 1} z ${total}`} className="w-full min-w-0 shrink-0 snap-start" data-id="element-130" data-mp="3oa1i9uqhxey9" data-mpi={pageIndex}>
              <div className="grid gap-6 md:grid-cols-2 md:items-center md:gap-8" data-id="element-131" data-mp="g09oeicqbs0u">
                <div className="relative min-w-0 overflow-hidden rounded-3xl bg-white p-3 shadow-soft sm:p-4" data-id="element-132" data-mp="fy6q7b1fasl1">
                  <img src={page.src} alt={`${page.title} — przykładowa strona, ${page.level}`} loading={pageIndex === 0 ? 'eager' : 'lazy'} className="block h-auto w-full rounded-xl" data-id="element-133" data-mp="18gu7sgh7nphd" />
                  <button type="button" onClick={() => goTo(pageIndex - 1)} aria-label="Poprzednia strona" className="absolute left-4 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:left-6" data-id="element-134" data-mp="1b3lc18qh5ntk">
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-135" data-mp="23pe9r3wwyc9h" />
                  </button>
                  <button type="button" onClick={() => goTo(pageIndex + 1)} aria-label="Następna strona" className="absolute right-4 top-1/2 z-10 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-ink/90 text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:right-6" data-id="element-136" data-mp="28pab0ve87plc">
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-137" data-mp="2ds9vx1z6uya5" />
                  </button>
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-5 left-1/2 -translate-x-1/2 rounded-full bg-ink/85 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-138" data-mp="28ugo64i8lw7r">
                    {pageIndex + 1} / {total}
                  </span>
                </div>

                <div className="min-w-0 md:pr-4" data-id="element-139" data-mp="1q25pynyj2mfz">
                  <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-140" data-mp="1q5jrxv3a4tmw">
                    {page.level}
                  </p>
                  <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-141" data-mp="31hawy45oz75e">
                    {page.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-142" data-mp="s9o5gwqzq921">
                    {page.caption}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="mt-3 text-center text-xs font-bold tabular-nums text-ink/40" data-id="element-143" data-mp="j8hrovfq7cch">
          {index + 1} / {total}
        </p>
      </div>
    </section>;
}